// // YouTube API スクリプトを追加
// const tag = document.createElement('script');
// tag.src = 'https://www.youtube.com/iframe_api';
// tag.async = true;
// document.head.appendChild(tag);

// // グローバル関数として定義
// window.onYouTubeIframeAPIReady = function() {
//   console.log("YouTube API Ready!");
//   for (let i = 0; i < youtubeData.length; i++) {
//     embedYoutube(i);
//   }
// };

function loadYouTubeAPI(callback) {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);

  // onYouTubeIframeAPIReady を一時的に待つ
  window.onYouTubeIframeAPIReady = callback;
}

loadYouTubeAPI(() => {
  console.log("YouTube API Ready!");
  for (let i = 0; i < youtubeData.length; i++) {
    embedYoutube(i);
  }
});

const animationSpinning = {
  fadeOut: [{ opacity: 1 }, { opacity: 0.5 }, { opacity: 0 }],
  fadeIn: [{ opacity: 0 }, { opacity: 0.5 }, { opacity: 1 }],
};

const animationTiming = { duration: 600 };

var youtubeData = [
  { youtubeId: '-CbrqhKDmz4', embedArea: 'ytVideo1' },
  { youtubeId: '8cS_oVDJW1c', embedArea: 'ytVideo2' },
  { youtubeId: 'UoiemVcZhBM', embedArea: 'ytVideo3' },
];

function embedYoutube(num) {
  new YT.Player(youtubeData[num].embedArea, {
    videoId: youtubeData[num].youtubeId,
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerFix,
    },
    playerVars: {
      autoplay: 0,
      rel: 0,
      playlist: youtubeData[num].youtubeId,
    },
  });
}

function onPlayerReady(event) {
  const playBtn = event.target.g.closest('.pg-mov').querySelector('.js-yt-playbtn');
  playBtn.addEventListener('click', () => {
    playBtn.animate(animationSpinning.fadeOut, animationTiming);
    setTimeout(() => { playBtn.style.display = 'none'; }, animationTiming.duration);
    event.target.mute();
    event.target.playVideo();
  });
}

function onPlayerFix(event) {
  const playBtn = event.target.g.closest('.pg-mov').querySelector('.js-yt-playbtn');
  if (event.data === YT.PlayerState.ENDED) {
    event.target.seekTo(0, true);
    event.target.stopVideo();
    playBtn.animate(animationSpinning.fadeIn, animationTiming);
    playBtn.style.display = 'block';
  }
}
